// export enum FraudActionTypeEnum {
//     Decline=1,
//     'Monitor'=2,
//     'Monitor&Decline'=3
// }

// export namespace FraudActionTypeEnum {
//     export function values() {
//         return Object.keys(FraudActionTypeEnum).filter(
//             (type) => isNaN(<any>type) && type !== 'values'
//         );
//     }
// }
export enum FraudActionTypeEnums {
	'Decline'=1,
	    'Monitor'=2,
	    'Monitor&Decline'=3
}

export function getFraudActionTypeValues(): string[] {
	return Object.keys(FraudActionTypeEnums).filter(
		(type) => isNaN(Number(type)) && type !== 'values'
	);
}
  